import { SECTION, NON_ADHERING_TO_SECTION_RULES_PAGES } from './config';

export function getSectionToExpand(path) {
	const pathParts = path.split('/');
	const section = pathParts[1];
	const page = pathParts[2];
	// Check if it's a 'special case' page
	const nonAdheringSection = NON_ADHERING_TO_SECTION_RULES_PAGES[page];
	if (nonAdheringSection) {
		return nonAdheringSection;
	}
	if (Object.values(SECTION).map((s) => s.toLowerCase()).includes(section.toLowerCase())) {
		return section.toLowerCase();
	}
	return null;
}

export function isReportsOverviewPath(path, availableReportPaths) {
	return path.includes('/reports')
		&& availableReportPaths.some((type) => path.endsWith(type));
}
